import { render, staticRenderFns } from "./AmazonumsaetzeChartBox.vue?vue&type=template&id=130d12a8&"
import script from "./AmazonumsaetzeChartBox.vue?vue&type=script&lang=js&"
export * from "./AmazonumsaetzeChartBox.vue?vue&type=script&lang=js&"
import style0 from "./AmazonumsaetzeChartBox.vue?vue&type=style&index=0&id=130d12a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports